import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggerService } from 'services/logger.service';

@Injectable()
export class AzureRefInterceptor implements HttpInterceptor {
  private readonly headerName = 'x-azure-ref';
  private readonly eventName = 'AzureRefCaptured';

  constructor(private readonly loggerService: LoggerService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const azureRef = event.headers.get(this.headerName);
            if (azureRef) {
              this.loggerService.trackEvent(this.eventName, {
                azureRef,
                url: req.url,
                status: event.status,
              });
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          const azureRef = error.headers?.get(this.headerName);
          if (azureRef) {
            this.loggerService.trackEvent(this.eventName, {
              azureRef,
              url: req.url,
              status: error.status,
            });
          }
        },
      })
    );
  }
}
